module.exports = __webpack_public_path__ + "img/stylist_revenue_icon.4c4f1380.svg";